import { useState } from 'react'
import { toast } from 'sonner'

import { DirectMessageModal } from '@/modules/messages/components/DirectMessageModal'
import { Button } from '@/shared/components/ui/button'
import { ConfirmDialog } from '@/shared/components/ui/ConfirmDialog'
import { PlaceholderPage } from '@/shared/components/ui/PlaceholderPage'

import { AddMarketingDialog } from '../components/marketing/AddMarketingDialog'
import { useMarketing } from '../hooks/useMarketing'

import AdminMarketingPage from './AdminMarketingPage'

export default function AdminMarketingRoute() {
  const [open, setOpen] = useState(false)
  const [selectedMarketing, setSelectedMarketing] = useState(null)

  const [confirmOpen, setConfirmOpen] = useState(false)
  const [marketingToDelete, setMarketingToDelete] = useState(null)

  // Direct Messaging State
  const [messageModalOpen, setMessageModalOpen] = useState(false)
  const [messagePartner, setMessagePartner] = useState(null)

  const { deleteMarketingPerson } = useMarketing()

  const handleAdd = () => {
    setSelectedMarketing(null)
    setOpen(true)
  }

  const handleEdit = (marketing) => {
    setSelectedMarketing(marketing)
    setOpen(true)
  }

  const handleDelete = (marketing) => {
    setMarketingToDelete(marketing)
    setConfirmOpen(true)
  }

  const handleMessage = (marketing) => {
    setMessagePartner(marketing)
    setMessageModalOpen(true)
  }

  const confirmDelete = async () => {
    if (!marketingToDelete) return

    try {
      await deleteMarketingPerson(marketingToDelete._id)

      toast.success('Marketing person deleted successfully.')

      setConfirmOpen(false)
      setMarketingToDelete(null)
    } catch (error) {
      toast.error('Failed to delete marketing person.')
      console.error(error)
    }
  }

  return (
    <div className="space-y-6">
      <PlaceholderPage
        title="Marketing"
        description="Manage marketing persons."
        action={
          <Button
            size="lg"
            className="bg-[#0F172A] hover:bg-[#1E293B] text-white rounded-2xl"
            onClick={handleAdd}
          >
            Add Marketing
          </Button>
        }
      />

      <AdminMarketingPage
        onEdit={handleEdit}
        onDelete={handleDelete}
        onMessage={handleMessage}
      />

      <AddMarketingDialog
        open={open}
        onOpenChange={setOpen}
        marketing={selectedMarketing}
      />

      <ConfirmDialog
        open={confirmOpen}
        onOpenChange={setConfirmOpen}
        title="Delete Marketing Person"
        description={`Are you sure you want to delete "${marketingToDelete?.name}"? This action cannot be undone.`}
        confirmText="Delete"
        cancelText="Cancel"
        onConfirm={confirmDelete}
      />

      <DirectMessageModal
        open={messageModalOpen}
        onOpenChange={setMessageModalOpen}
        partner={messagePartner}
      />
    </div>
  )
}
